export const peoCharges = {
  administrativeServicekey: [
    {
      question:
        "<strong>Payroll Administration:</strong> per Check Processing Fee; Direct Deposit Payroll Card Administration",
      questionId: 0,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Year-End W2 Processing Set Up",
      questionId: 1,
      dropDown: "no",
      response: 525,
    },
    {
      question: "Year-End W2 Processing (per employee cost)",
      questionId: 2,
      dropDown: "yes",
      dropDown: "no",
      response: 5.25,
    },
    {
      question:
        "<strong>Human Resources:</strong> HR Administration & Consulting Administration",
      questionId: 3,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question:
        "<strong>Employee Benefits:</strong> Medical, Dental & Vision Benefits Administration; Section 125 (cafeteria) Plan",
      questionId: 4,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question:
        "<strong>Workers’ Compensation:</strong> Safety & Claims Administration",
      questionId: 5,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Waiver of subrogation (per waiver fee)",
      questionId: 6,
      dropDown: "no",
      response: 125.0,
    },
    {
      question:
        "<strong>Business Essentials: </strong>Employment Practice Liability Insurance per Annum,per Employee (pro-rated by payroll cycle)",
      questionId: 7,
      dropDown: "no",
      response: 156,
    },
    {
      question:
        "Client Company Cyber Insurance Per Annum, per employee (pro-rated by payroll cycle)",
      questionId: 8,
      dropDown: "no",
      response: 26,
    },
  ],

  optionalAdditionalServiceKey: [
    {
      question:
        "<strong>Payroll Administration:</strong> Time & Attendance GPS Enabled Smart Timeclock App per Annum, per employee (pro-rated by payroll cycle)",
      questionId: 0,
      dropDown: "no",
      response: "Priced on Request",
    },
    {
      question:
        "<strong>Employee Benefits: </strong> Master 401 (K) per Employee Set Up (one-time fee); Master 401 (K) per Employee Annual Maintenance; 401 (K) Administration",
      questionId: 1,
      dropDown: "no",
      response: "Priced on Request",
    },
    {
      question:
        "<strong>Business Essentials: </strong>Wage & Hour Endorsement for Employment Practice Liability Insurance per Annum,per Company (pro-rated by payroll cycle, $50k policy limit)",
      questionId: 2,
      dropDown: "no",
      response: "Priced on Request",
    },
    {
      question:
        "<strong>Additional Services:</strong> On-site Check Printer Lease (includes MICR toner, check stock and envelopes) per Annum (pro-rated by payroll cycle)",
      questionId: 3,
      dropDown: "no",
      response: 995,
    },
    {
      question:
        "On-site Check Printer Purchase (includes MICR toner, check stock and envelopes) One-Time Purchase",
      questionId: 4,
      dropDown: "no",
      response: 695,
    },
  ],

  programDetailsAdditionalServiceKey: [
    {
      question:
        "Claims Management, A-Rated National Insurance Carriers, No Year-End Assessments, Contract Rates Guaranteed Each Year, Post-Accident Drug Testing, Inspections, Reporting, Data Tracking, Accident Prevention Programs, Back to Work Policy, Toll-Free Service for Medical Care Reporting and Management",
      questionId: 0,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Claim Contribution Fee per Incident",
      questionId: 1,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 2500,
    },
    {
      question:
        "Claim Contribution Fee Increase for Late Claim Reporting Penalty per Incident (claims reported to IES more than 5 working days after incident)",
      questionId: 2,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 2500,
    },
    {
      question: "Set Up Fee",
      questionId: 3,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 0,
    },
    {
      question: "Deposit",
      questionId: 4,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 0,
    },
    {
      question:
        "Minimum Invoice Charge (Program maintenance fee charged per payroll cycle)",
      questionId: 5,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 0,
    },
  ],
};
